import get from 'lodash/get';

import { hasFeature } from '../../../participant/util/has-feature';
import { RESULT__FETCH, RESULT__INIT } from '../constants';

const defaultState = { errorImage: null, logo: null, enabled: hasFeature('branding') };

export default function (state = defaultState, action) {
  switch (action.type) {
    case RESULT__FETCH:
    case RESULT__INIT:
      return {
        ...state,
        errorImage: get(
          action,
          'data.result.theme.organization_error_image.original_url',
          defaultState.errorImage,
        ),
        logo: get(action, 'data.result.theme.organization_logo.small_url', defaultState.logo),
      };
    default:
      return state;
  }
}
